import { render } from "./EstudioCrear.vue?vue&type=template&id=5c5b455a"
import script from "./EstudioCrear.vue?vue&type=script&lang=js"
export * from "./EstudioCrear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__